import React from 'react'
import {
  Container,
  StyledText,
  StyledImage,
} from './_styled/secure-payment.styled'

const icons = ['mastercard', 'visa', 'amex', 'paypal', 'unionpay', 'alipay', 'wechatpay-2']

const SecurePayment = ({ title }) => (
  <Container>
    <StyledText text={title} type="body" />
    {icons.map((icon, index) => (
      // TODO uncomment StyledIcon with type prop when
      // icons are added to Sprite
      // <StyledIcon key={index.toString()} type={icon} />
      <StyledImage
        key={index.toString() + Date('now')}
        src={`/images/${icon}.svg`}
        alt={`${icon} logo`}
      />
    ))}
  </Container>
)

export default SecurePayment
